import ENDPOINTS from "../endpoints";

const authHeaders = (json = true) => {
    const headers = { Accept: "application/json" };
    if (json) {
        headers["Content-Type"] = "application/json";
    }
    const token = localStorage.getItem("jwtToken");
    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }
    return headers;
};

const parseError = async (response) => {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || `HTTP error! Status: ${response.status}`);
};

/** GET /api/news?page=&limit= */
export const getNewsList = async (page, limit) => {
    const url = new URL(ENDPOINTS.NEWS.LIST);
    url.searchParams.set("page", String(page));
    url.searchParams.set("limit", String(limit));

    const response = await fetch(url.toString(), {
        method: "GET",
        headers: { Accept: "application/json" },
    });

    if (!response.ok) {
        await parseError(response);
    }

    const data = await response.json();

    return {
        items: data.items ?? [],
        totalCount: Number(response.headers.get("totalCount") ?? 0),
    };
};

/** GET /api/news/{id} */
export const getNewsById = async (id) => {
    const response = await fetch(ENDPOINTS.NEWS.BY_ID(id), {
        method: "GET",
        headers: authHeaders(),
    });

    if (!response.ok) {
        await parseError(response);
    }

    return response.json();
};

/** POST /api/news — multipart: image, dateTime, description, link_url */
export const createNews = async (formData) => {
    const response = await fetch(ENDPOINTS.NEWS.LIST, {
        method: "POST",
        headers: authHeaders(false),
        body: formData,
    });

    if (!response.ok) {
        await parseError(response);
    }

    return response.json();
};

/** PUT /api/news/{id} */
export const updateNews = async (id, formData) => {
    const response = await fetch(ENDPOINTS.NEWS.BY_ID(id), {
        method: "PUT",
        headers: authHeaders(false),
        body: formData,
    });

    if (!response.ok) {
        await parseError(response);
    }

    return response.json();
};

/** DELETE /api/news/{id} */
export const deleteNews = async (id) => {
    const response = await fetch(ENDPOINTS.NEWS.BY_ID(id), {
        method: "DELETE",
        headers: authHeaders(),
    });

    if (!response.ok) {
        await parseError(response);
    }

    const contentLength = response.headers.get("Content-Length");
    if (contentLength === "0") {
        return null;
    }

    return response.json().catch(() => null);
};
